import ApiServices from "./ApiServices";
import gql from "graphql-tag";

export default class LmsService extends ApiServices {
  constructor(credential = 'include') {
    super('/api/v1/lms/', credential);
  }

  async getProof(proof_id, fetchPolicy = "") {
    return await this.apolloClass.query({
      query: gql`
          query getProof($proof_id: Int!){
              proof(id: $proof_id) {
                  minimum,
                  attempts,
                  questions {
                      id
                      title
                      answers {
                          id
                          title
                          is_correct
                      }
                  }
              }
          }`,
      variables: {
        proof_id
      },
      fetchPolicy
    });
  }

  async getTrailItemHasUser(trail_id){
    return await this.apolloClass.query({
      query: gql`
        query getTrailItemHasUser($trail_id: Int!){
          trail_itens_by_user(trail_id: $trail_id) {
            trailitenshasuser{
              item_id, item_type
            }
          }
        }
     `,
       variables: {
         trail_id
       }
    })
  }

  async getAnswerQuestion(variables = {}) {
    return await this.apolloClass.query({
      query: gql`
          query answer_question_collections($proof_id: Int!, $item_id: Int!, $item_type: String!){
              answer_question_collections(proof_id: $proof_id, item_id: $item_id, item_type: $item_type){
                  answers_question{
                      id
                  }
              }
          }`,
      variables,
    });
  }

  async userProofsCollection(variables = {}) {
    return await this.apolloClass.query({
      query: gql`
          query userProofs_collections($proof_id: Int!, $course_id: Int, $trail_id: Int) {
              userProofs_collection(proof_id: $proof_id, course_id: $course_id, trail_id: $trail_id) {
                  userproofs {
                      id,
                      grade,
                      approved,
                      attempt,
                      proof_id,
                      user_id
                  }
              }
          }`,
      variables
    });
  }

  async courseHasUserItem(course_id) {
    return await this.apolloClass.query({
      query: gql`
          query course_has_user_item($course_id: Int!) {
              course_has_user_item(course_id: $course_id){
                  id
              }
          }
      `,
      variables: {
        course_id,
      },
    });
  }

  async createUserProof(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation createUserProof($proof_id: Int!, $course_id: Int, $trail_id: Int, $approved: Boolean!, $grade: Int!, $total_question: Int!) {
              createUserProof(input: {proof_id: $proof_id, course_id: $course_id, trail_id: $trail_id, approved: $approved, grade: $grade, total_question: $total_question}) {
                  id
                  __typename
              }
          }
      `,
      variables
    })
  }


  async trailHasUserItem(trail_id) {
    return await this.apolloClass.query({
      query: gql`
          query trail_has_user_item($trail_id: Int!) {
              trail_has_user_item(trail_id: $trail_id){
                  id
              }
          }
      `,
      variables: {
        trail_id,
      },
    });
  }

  async createUserProof(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation createUserProof($proof_id: Int!, $course_id: Int, $trail_id: Int, $approved: Boolean!, $grade: Int!, $total_question: Int!) {
              createUserProof(input: {proof_id: $proof_id, course_id: $course_id, trail_id: $trail_id, approved: $approved, grade: $grade, total_question: $total_question}) {
                  id
                  __typename
              }
          }
      `,
      variables
    })
  }

  async finishProof(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation addAnswerQuestion($course_id: Int!, $status: String!){
              updateCourseHasUser(input:{course_id:$course_id, status:$status}) {
                  id
              }
          }`,
      variables
    });
  }

  async finishTrail(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation addAnswerQuestion($trail_id: Int!, $status: String!){
              updateTrailHasUser(input:{trail_id:$trail_id, status:$status}) {
                  id
              }
          }`,
      variables
    });
  }

  async saveAnwserQuestion(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation addAnswerQuestion($answer_id: Int!, $question_id: Int!, $item_id: Int!, $item_type: String!){
              createAnswerQuestion(input: {answer_id: $answer_id, question_id: $question_id, item_id: $item_id, item_type: $item_type}) {
                  id
              }
          }`,
      variables
    });
  }

  async getCourses(fetchPolicy = "") {
    return await this.apolloClass.query({
      query: gql`{
          courses_collections{
              courses{
                  id,title,thumbnail
              }
          }
      }`,
      fetchPolicy
    });
  }

  async getQuatityCourses(category_id) {
    return this.apolloClass.query({
      query: gql`
        query quantidadeCursos($category_id: Int) {
          courses_count(portoeduc: 1, category_id: $category_id) {
            count
          }
        }
    `,variables: {
      category_id
    }
  });
  }

  async getCourse(id, fetchPolicy = "") {
    return await this.apolloClass.query({
      query: gql`
          query getCourse($id: Int!) {
              course(id:$id){
                  id,
                  title,
                  description,
                  scorm,
                  external_view,
                  hours,
                  minutes,
                  thumbnail,
                  code,
                  type,
                  category_id,
                  active,
                  video{
                      id, thumbnail
                  },
                  proof{
                      id, title
                  },
                  reactionevaluation{
                      id, title
                  }
              }
          }
      `,
      variables: {
        id
      },
      fetchPolicy
    });
  }

  async saveTrailItemHasUser(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
          mutation trailItemHasUser($trail_id: Int!, $item_id: Int!, $item_type: String!){
              createTrailItemHasUser(input:{trail_id:$trail_id, item_id:$item_id, item_type:$item_type}){
                  id
              }
          }
      `,
      variables
    });
  }

  async saveVideoHasUser(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
        mutation insert_user_has_video($video_id: String!, $defaultProject: Boolean){
          insert_user_has_video(video_id: $video_id, defaultProject: $defaultProject){
          id
          }
        }
      `,
      variables
    });
  }

  async saveVideoHasUserFinish(variables) {
    return await this.apolloClass.mutate({
      mutation: gql`
         mutation finish_user_has_video($video_id: String!){
          finish_user_has_video(video_id: $video_id) {
          id
          }
         }
      `,
      variables
    });
  }

  async createCourseGTM(course_id, item_id) {
    return this.apolloClass.mutate({
      mutation: gql`
        mutation createCourseGTM($course_id: Int!, $item_id: Int! ) {
          createCourseGTM(course_id: $course_id, item_id: $item_id) {
            id
          }
        }
      `,
      variables: {
        course_id,
        item_id
      },
    });
  }

  async createTrailGTM(trail_id, item_id) {
    return this.apolloClass.mutate({
      mutation: gql`
        mutation createTrailGTM($trail_id: Int!, $item_id: Int! ) {
          createTrailGTM(trail_id: $trail_id, item_id: $item_id) {
            id
          }
        }
      `,
      variables: {
        trail_id,
        item_id
      },
    });
  }

  async searchCourse(search) {
    return await this.apolloClass.query({
      query: gql`
        query getItens($search: String!){
          search_courses_collections(search:$search, type: "online") {
            courses{
              id, title, thumbnail, description, hours, minutes
            }
          }
        }
      `,
      variables: {
        search
      },
    });
  }

  async getUserHasVideo(course_id) {
    return await this.apolloClass.query({
        query: gql`
          query user_has_video($course_id: Int!) {
              user_has_video(course_id: $course_id) {
                id
              }
            }
        `,
        variables: {
          course_id
        }
    });
  }

  async searchVideo(search) {
    return await this.apolloClass.query({
      query: gql`
        query getVideos($search: String!){
          videos_collections_search(search:$search){
            videos{
              id, title, thumbnail
            }
          }
        }
      `,
      variables: {
        search
      },
    });
  }

  async searchAulasGravadas(search) {
    return await this.apolloClass.query({
      query: gql`
        query getAulasGravadas($search: String!){
          videos_list_by_category_search(search: $search){
            videos{
              id, title, thumbnail, is_viewed
            }
          }
        }
      `,
      variables: {
        search
      },
    });
  }

  async searchTrails(search) {
    return await this.apolloClass.query({
      query: gql`
        query getTrails($search: String!){
          trail_list_search(search: $search){
            trailitems{
              item_id,
              item_type
              trail{
                id,
                title,
                thumbnail, 
                description, 
                hours, 
                minutes,
                modules,
              }
            }
          }
        }
      `,
      variables: {
        search
      },
    });
  }

  async getTrail(id) {
    return await this.apolloClass.query({
      query: gql`
        query getTrail($id: Int!){
          trail(id: $id){
            active,
            title,
            proof {
              id
            }
          }
        }
        `,
        variables: {
          id
        },
    })
   }

   async getCourseGTM(course_id, item_id) {
     return this.apolloClass.query({
       query: gql`
         query getCourseGTM($course_id: Int!, $item_id: Int!) {
          courseGTM(course_id: $course_id, item_id: $item_id) {
              id
          }
         }
       `,
       variables: {
        course_id,
        item_id
       }
     });
   }

   async getTrailGTM(trail_id, item_id) {
    return this.apolloClass.query({
      query: gql`
        query getTrailGTM($trail_id: Int!, $item_id: Int!) {
         trailGTM(trail_id: $trail_id, item_id: $item_id) {
             id
         }
        }
      `,
      variables: {
       trail_id,
       item_id
      }
    });
  }

   async getTrailItems(trail_id) {
     return this.apolloClass.query({
       query:  gql`
        query getItens($trail_id: Int!){
          trailitems(trail_id:$trail_id) {
            trailitems{
              id, item_id, item_type
            }
          }
        }
     `,
     variables: {
      trail_id,
     }
     });
   }

   async getCategoryHasTrail(trail_id) {
     return this.apolloClass.query({
       query: gql `
         query getCategoryHasTrail($trail_id: Int!){
          categoryHasTrail_collection(trail_id: $trail_id) {
              category_has_trail {
                id,
                category_id
              }
            }
         }
       `,
       variables: {
         trail_id,
       }
     });
   }

   async getCategoryHasCourse(course_id) {
    return this.apolloClass.query({
      query: gql `
        query getCategoryHasCourse($course_id: Int!){
          categoryHasCourse_collection(course_id: $course_id) {
            category_has_course {
               id,
               category_id
             }
           }
        }
      `,
      variables: {
        course_id,
      }
    });
  }

};



// WEBPACK FOOTER //
// ./src/services/LmsService.js